import React, { useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { toast } from "react-toastify";
import { ModeloPost } from "../../ModeloCrud";
import { useAuditoria } from "../contexts/AuditoriaContext";
import RelatedPrestacionesGrid from "./RelatedPrestacionesGrid";
import LanOutlinedIcon from "@mui/icons-material/LanOutlined";
import ModalConfirmation from "../../modals/ModalConfirmation";
import DeleteModel from "../../DeleteModel";

const PanelPrestacionesRelacionadas = ({
  heightLimit = 240,
  onRefacturarDone,
  relacionadas = [],
}) => {
  const theme = useTheme();
  const { auditoriaActivaId } = useAuditoria();
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [selectedPrestacion, setSelectedPrestacion] = useState(null);
  const [deleteRefacturacionId, setDeleteRefacturacionId] = useState(null);

  const handleRefacturarApi = async () => {
    if (!selectedPrestacion) return;

    try {
      const resultado_auditoria =
        selectedPrestacion.auditoria === "X" ||
        selectedPrestacion.auditoria === "O" ||
        selectedPrestacion.auditoria === "L"
          ? "F"
          : "O";

      const body = { resultado_auditoria };

      const result = await ModeloPost(
        "auditoria",
        auditoriaActivaId,
        "refacturar/" + selectedPrestacion.id,
        body
      );

      if (result.error) {
        toast.error(
          "Error: " + (result.mensaje ?? "Error al refacturar prestación")
        );
      } else {
        toast.success("Prestación refacturada correctamente");
        if (onRefacturarDone) await onRefacturarDone();
      }
    } catch (error) {
      toast.error("Error al refacturar prestación");
    } finally {
      setDisplayConfirmationModal(false);
      setSelectedPrestacion(null);
    }
  };

  const handleRefacturar = async (prestacion) => {
    const {
      id,
      auditoria_id,
      auditoria_refacturacion,
      periodo_refacturacion,
      id_refacturacion,
    } = prestacion;

    try {
      if (auditoria_id === auditoriaActivaId) {
        toast.info(
          "Tratamiento en el mismo período de auditoría. Auditelo normalmente."
        );
        return;
      }
      if (auditoria_refacturacion === auditoriaActivaId) {
        setDeleteRefacturacionId(id_refacturacion);
        return;
      }
      if (
        auditoria_refacturacion > 0 &&
        auditoria_refacturacion !== auditoriaActivaId
      ) {
        toast.info(
          `Tratamiento refacturado en período ${periodo_refacturacion} `
        );
        return;
      }

      setSelectedPrestacion(prestacion);
      setModalMessage(
        `¿Desea refacturar la prestación ${id} de auditoría ${auditoria_id} ?`
      );
      setDisplayConfirmationModal(true);
    } catch (error) {
      toast.error("Ocurrió un error al refacturar");
      console.error(error);
    }
  };

  if (!relacionadas.length) return null;

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
            mb: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LanOutlinedIcon color="primary" fontSize="small" />
            <Typography variant="body1" color="text.secondary">
              Prestaciones relacionadas
            </Typography>
          </Box>
        </Box>

        <Box sx={{ maxHeight: heightLimit, overflowY: "auto" }}>
          <RelatedPrestacionesGrid
            rows={relacionadas}
            onRefacturar={handleRefacturar}
          />
        </Box>
      </Box>

      <ModalConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleRefacturarApi}
        hideModal={() => setDisplayConfirmationModal(false)}
        message={modalMessage}
      />

      {deleteRefacturacionId !== null && (
        <DeleteModel
          model={"refacturacion"}
          modelid={deleteRefacturacionId}
          okmethod={onRefacturarDone}
          nullmethod={() => setDeleteRefacturacionId(null)}
          deleteMessage="Tratamiento ya refacturado. ¿Desea quitar la refacturación?"
        />
      )}
    </>
  );
};

export default PanelPrestacionesRelacionadas;
